import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { Box, Fade } from "@mui/material";
import BaseUrl from "../BaseUrl";
import { useHistory } from "react-router-dom";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import Backdrop from "@mui/material/Backdrop";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 200,
};

const WorkspaceModalUi = ({ openModal, modalSetterFun, addEmailSetterFun }) => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [isCopiedText, setIsCopiedText] = useState(false);
  const history = useHistory();

  const copyToClipboard = () => {
    const input = document.getElementById("google_app_id");
    navigator.clipboard.writeText(input.value);
    setIsCopiedText(true);
    setTimeout(() => {
      setIsCopiedText(false);
    }, 2000);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openModal}
      onClose={() => modalSetterFun(false)}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={openModal}>
        <Box sx={style}>
          <div className="space-y-4">
            <video controls width="200" height="200">
              <source
                src="https://www.youtube.com/watch?v=-F-L3yVE1yk&ab_channel=mallemalatv"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <p
              style={{
                color: "#4B4B4B",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span className="rounded-md">1.</span> Have your Google Workspace
              Administrator go to{" "}
              <a
                style={{
                  textDecoration: "underline",
                  color: "blue",
                  fontWeight: 500,
                }}
                href="https://admin.google.com/u/1/ac/owl/list?tab=configuredApps"
                target="_blank"
              >
                App Access Control
              </a>
            </p>
            <p
              style={{
                color: "#4B4B4B",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span
                className="rounded-md"
              >
                2.
              </span>{" "}
              Click "Add App" and then select "OAuth App Name or Client ID"
            </p>
            <div>
              <p
                style={{
                  color: "#4B4B4B",
                  fontWeight: "400",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <span
                  className="rounded-md"
                >
                  3.
                </span>{" "}
                Search for coldsender.com by using our Google App ID:
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F0F5FF",
                  borderRadius: "6px",
                  marginTop: "6px",
                  padding: "0px 10px",
                }}
              >
                <input
                  type="text"
                  id="google_app_id"
                  disabled={true}
                  value="414481019921-b6rv7dlbcrhgl7o5cvjrg31o8kvjaj9m.apps.googleusercontent.com"
                  style={{
                    outline: "none",
                    padding: "12px 0px",
                    backgroundColor: "transparent",
                    flexGrow: 1,
                    color: "#000",
                  }}
                />
                <button onClick={copyToClipboard}>
                  {isCopiedText ? (
                    <DoneAllOutlinedIcon />
                  ) : (
                    <ContentCopyOutlinedIcon />
                  )}
                </button>
              </div>
            </div>
            <p
              style={{
                color: "#4B4B4B",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span
                className="rounded-md"
              >
                4.
              </span>{" "}
              Select and approve coldsender.com and complete the wizard.
            </p>
            <p
              style={{
                color: "#4B4B4B",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span
                className="rounded-md"
              >
                5.
              </span>{" "}
              And that’s it! Once done, you are okay to continue to connect.
            </p>
            <div>
              <p
                className="done-with-btn cursor-pointer"
                onClick={() => {
                  history.push("/Email/accounts/settings");
                  modalSetterFun(false);
                  addEmailSetterFun(false);
                }}
              >
                Want to connect with app password?
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: "12px",
              gap: "13px",
            }}
          >
            <button
              onClick={() => {
                modalSetterFun(false);
              }}
              style={{
                border: "1px solid #1C485F",
                outline: "none",
                color: "#1C485F",
                padding: "9px 16px",
                fontSize: "14px",
                fontWeight: "400",
                borderRadius: "4px",
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                // setOpenWorkSpaceModal(false);
                window.location.href = `${
                  BaseUrl.baseurl
                }/email-marketing/user/get-email-google-code/${
                  userDetails && userDetails.details._id
                }`;
              }}
              style={{
                textTransform: "none",
                outline: "none",
                color: "#fff",
                padding: "10px 26px",
                fontSize: "14px",
                fontWeight: "400",
                borderRadius: "6px",
              }}
              className="bg-primary"
            >
              Done
            </button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default WorkspaceModalUi;
